import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Notification from './Notification';
import { remove } from '../slices/notifications';

export default function NotificationHolder() {
    const { ids, notifications } = useSelector(state => state.notifications);
    const dispatch = useDispatch();
    const removeNotification = useCallback(
        id => dispatch(remove(id)),
        [dispatch],
    );

    return (
        <>
            <div className="fixed bottom-0 right-0 px-4 py-8 pointer-events-none sm:pb-8 sm:pt-6 space-y-4 z-30">
                {ids.map(id => {
                    const notification = notifications[id];
                    return (
                        <Notification
                            key={id}
                            id={id}
                            variant={notification.variant}
                            title={notification.title}
                            message={notification.message}
                            autoDelete={notification.autoDelete}
                            removeNotification={removeNotification}
                            actions={notification.actions || []}
                        />
                    );
                })}
            </div>
        </>
    );
}
